import script from "./typography-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./typography-icon.vue?vue&type=script&setup=true&lang=js"

import "./typography-icon.vue?vue&type=style&index=0&id=12c973df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c973df"]])

export default __exports__